import { FC, memo, useCallback, useMemo } from 'react'

import { Form, useFormData } from 'brief-form'
import { DatePicker, Select } from 'ui/components'
import { IntegerInput, TextInput } from 'ui/components/InputV2'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter'

import { SARListForm } from '../../types'
import { FilterFormProps } from './FilterFormProps'

import * as SC from './styles'

export const FilterForm: FC<FilterFormProps> = memo(({ optionStatus, tableConfig, data }) => {
  const { onClear, onFilterChange } = tableConfig

  const initialFilter: SARListForm = useMemo(
    () => ({
      batchId: data.form.batchId || null,
      bsaTrackingId: data.form.bsaTrackingId || null,
      date: data.form.date || null,
      status: data.form.status || null,
      page: data.form.page,
      size: data.form.size
    }),
    [data.form]
  )

  const formData = useFormData<SARListForm>({
    initialValue: initialFilter,
    onFormChanged: onFilterChange
  })
  const { isDirty, config, Field, set } = formData

  const reset = useCallback(() => {
    set({ reset: true })
    onClear()
  }, [onClear, set])

  return (
    <FilterPanel isDirty={isDirty} onReset={reset}>
      <FilterWrapper>
        <Form config={config}>
          <SC.Row>
            <SC.LeftWrapper>
              <Field name="batchId" label="Batch ID" input={IntegerInput} inputProps={{}} />
              <Field name="bsaTrackingId" label="BSA Tracking ID" input={TextInput} inputProps={{}} />
            </SC.LeftWrapper>
            <SC.RightWrapper>
              <Field name="date" label="Date" input={DatePicker} inputProps={{}} />
              <Field
                name="status"
                label="Status"
                input={Select}
                inputProps={{
                  data: optionStatus
                }}
              />
            </SC.RightWrapper>
          </SC.Row>
        </Form>
      </FilterWrapper>
    </FilterPanel>
  )
})
